/** Validación y formato de correo/celular para envío de recibo en inscripciones. */
export default {
  methods: {
    normalizarEmailRecibo ( email ) {
      if ( !email || typeof email !== 'string' ) return ''
      return email.trim().toLowerCase()
    },

    esEmailReciboValido ( email ) {
      if ( !email || typeof email !== 'string' ) return false
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test( email.trim() )
    },

    sincronizarEmailReciboAlumno ( alumno ) {
      if ( !alumno ) return ''
      const email = this.normalizarEmailRecibo( alumno.email )
      alumno.email = email
      return email
    },

    // WhatsApp recibo: deshabilitado temporalmente
    // esCelularReciboValido ( celular ) {
    //   if ( celular == null || celular === '' ) return true
    //   const digits = String( celular ).replace( /\D/g, '' ).slice( -10 )
    //   return /^[0-9]{10}$/.test( digits )
    // },

    // celularDesdeTwilioAsignado ( twilioAsignado ) {
    //   if ( !twilioAsignado ) return ''
    //   const raw = String( twilioAsignado ).trim()
    //   if ( !raw || raw === '0' || raw === 'null' ) return ''
    //   const digits = raw.replace( /\D/g, '' ).slice( -10 )
    //   return digits.length === 10 ? digits : ''
    // },

    // inicializarCelularWhatsAppPago ( alumno, celularRef ) {
    //   if ( celularRef && String( celularRef ).trim() ) return celularRef
    //   const desdeTwilio = alumno && alumno.twilio_asignado
    //     ? this.celularDesdeTwilioAsignado( alumno.twilio_asignado )
    //     : ''
    //   if ( desdeTwilio ) return desdeTwilio
    //   if ( alumno && alumno.celular ) {
    //     const digits = String( alumno.celular ).replace( /\D/g, '' ).slice( -10 )
    //     if ( digits.length === 10 ) return digits
    //   }
    //   if ( alumno && alumno.telefono ) {
    //     const digits = String( alumno.telefono ).replace( /\D/g, '' ).slice( -10 )
    //     if ( digits.length === 10 ) return digits
    //   }
    //   return ''
    // },

    validarContactoReciboPago ( email ) {
      if ( !this.esEmailReciboValido( email ) ) {
        return 'Favor de ingresar un correo válido para enviar el comprobante'
      }
      // if ( celular && !this.esCelularReciboValido( celular ) ) {
      //   return 'El número de celular debe tener 10 dígitos'
      // }
      return null
    },

    celularReciboInformado ( celular ) {
      return false // WhatsApp recibo deshabilitado temporalmente
      // if ( celular == null || celular === '' ) return false
      // const digits = String( celular ).replace( /\D/g, '' ).slice( -10 )
      // return digits.length === 10
    },

    hermanosConWhatsAppRecibo ( hermanos ) {
      return false // WhatsApp recibo deshabilitado temporalmente
      // if ( !Array.isArray( hermanos ) ) return false
      // return hermanos.some(( h ) => this.celularReciboInformado( h.celular_whatsapp ) )
    },

    confirmarWhatsAppReciboActivo () {
      return true // WhatsApp recibo deshabilitado temporalmente
      // return window.confirm(
      //   'Antes de procesar, verifique que el alumno haya enviado al menos un mensaje por WhatsApp a la línea oficial de la escuela.\n\n' +
      //   'Sin conversación activa en Twilio no se podrá enviar el comprobante por WhatsApp.\n\n' +
      //   '¿Desea continuar con el procesamiento del pago?'
      // )
    },

    formatearMontoReciboPago ( monto ) {
      const n = parseFloat( monto )
      if ( !Number.isFinite( n ) ) return '0.00'
      return n.toFixed( 2 )
    },

    /** Efectivo (tipo_pago 1) no valida comprobante. Solo bloquea si capturado > comprobante + $1. */
    validarMontoCapturadoVsComprobante () {
      if ( this.tipo_pago == 1 ) return true

      const capturado = parseFloat( this.total_pagado )
      if ( !Number.isFinite( capturado ) ) return true

      const montoImagen = parseFloat( this.monto_imagen )
      // OCR a veces deja $1.27 por $1,269.00; un colegiatura nunca es < $50
      const montoLeido = Number.isFinite( montoImagen ) && montoImagen >= 50

      if ( !montoLeido ) {
        return window.confirm(
          'No se pudo leer el monto del comprobante; verifique antes de continuar.\n\n¿Desea procesar el pago de todas formas?'
        )
      }

      const tolerancia = 1
      if ( capturado > montoImagen + tolerancia ) {
        this.validarErrorDirecto(
          `El monto capturado ($${this.formatearMontoReciboPago( capturado )}) no puede ser mayor al del comprobante ($${this.formatearMontoReciboPago( montoImagen )})`
        )
        return false
      }

      return true
    },

    actualizarCorreoAlumnoRegistrado ({ id_alumno, email, alumno }) {
      const emailNorm = alumno
        ? this.sincronizarEmailReciboAlumno( alumno )
        : this.normalizarEmailRecibo( email )

      const errorContacto = this.validarContactoReciboPago( emailNorm )
      if ( errorContacto ) {
        return this.validarErrorDirecto( errorContacto )
      }

      if ( !id_alumno ) {
        return this.validarErrorDirecto( 'No se encontró el alumno' )
      }

      this.cargar = true
      return this.$http.post( 'actualizar.email.alumno', { id_alumno, email: emailNorm } ).then( response => {
        if ( alumno ) {
          alumno.email = emailNorm
        }
        this.validarSuccess( response.data.message || 'Correo del alumno actualizado correctamente' )
      }).catch( error => {
        this.validarError( error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Error al actualizar el correo' )
      }).finally( () => { this.cargar = false } )
    },
  },
}
